"use client";
import { Box, Button, CircularProgress } from "@mui/material";

type DualButtonPropsBase = {
	cancelText: string;
	submitText: string;
	onCancel: () => void;
	loading?: boolean;
	disableSubmit?: boolean;
};

type DualButtonPropsWithButton = DualButtonPropsBase & {
	submitButtonType?: "button";
	onSubmit: () => void;
};

type DualButtonPropsWithSubmit = DualButtonPropsBase & {
	submitButtonType: "submit";
	onSubmit?: never;
};

type DualButtonProps = DualButtonPropsWithButton | DualButtonPropsWithSubmit;

export default function DualButton({
	cancelText,
	submitText,
	onCancel,
	onSubmit,
	submitButtonType = "button",
	loading = false,
	disableSubmit = false,
}: DualButtonProps) {
	return (
		<Box sx={{ display: "flex", gap: 4 }}>
			<Button
				variant="contained"
				color="secondary"
				onClick={onCancel}
				disabled={loading}
				type="button"
				sx={{ minWidth: 110 }}
			>
				{cancelText}
			</Button>
			<Button
				variant="contained"
				color="primary"
				onClick={submitButtonType === "button" ? onSubmit : undefined}
				type={submitButtonType}
				disabled={loading || disableSubmit}
				sx={{ color: "#FFFFFF", minWidth: 110, position: "relative" }}
			>
				{loading ? (
					<CircularProgress
						size={24}
						color="inherit"
						sx={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
						}}
					/>
				) : (
					submitText
				)}
			</Button>
		</Box>
	);
}
